import { reactive } from 'vue'

// What the POS's pages show of Johku Hub's messages (the menu's count, the Messages item, the order's
// Conversation tab). Apart from lib/hub.js, which loads Hub's code: the pages import this at once and
// lib/hub.js only for a shop with the hubmessaging feature flag.
export const hubState = reactive({
  // The signed-in user has the shop's inbox
  available: false,
  unread: 0,
  // Orders whose conversation with the customer has unread messages (order ids as strings)
  unreadOrders: [],
  // Why the messages can't be shown: the POS server's error code (HUB_NOT_A_MEMBER, …)
  problem: ''
})
